var _defs, _polyline, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #001213;\n        stroke-miterlimit: 10;\n        stroke-width: 7px;\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "74.4 100.4 52 78 74.4 55.6"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "29.6 55.6 52 78 29.6 100.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineClose);
export default __webpack_public_path__ + "static/media/line_close.1a983f387a0b97edccd21201c0a131ad.svg";
export { ForwardRef as ReactComponent };